import clsx from 'clsx'
import { ChangeEvent, FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { QueueNodeCompleteActionEnum } from '@models/queueProcess'

import { FormControl } from '@components/FormControl'

type Props = {
  isEnding?: boolean
  value: QueueNodeCompleteActionEnum
  onChange: (value: QueueNodeCompleteActionEnum) => void
}

const CompleteQueueTypeRadioButton: FC<Props> = ({ value, onChange, isEnding }) => {
  const intl = useIntl()

  const handleChange = ({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
    onChange(currentTarget.value as QueueNodeCompleteActionEnum)
  }

  return (
    <FormControl>
      <FormControl.Label isRequired>
        <FormattedMessage id="queue_node.complete.action" />
      </FormControl.Label>
      <div className="row">
        {Object.values(QueueNodeCompleteActionEnum).map((action) => {
          if (!isEnding && action === QueueNodeCompleteActionEnum.END) return null

          return (
            <div
              className="col"
              key={action}
            >
              <label
                className={clsx('btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6', {
                  active: value === action,
                })}
              >
                <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="complete_action"
                    onChange={handleChange}
                    value={action}
                    checked={value === action}
                  />
                </span>
                <span className="ms-5">
                  <span className="fs-4 fw-medium text-gray-800 d-block">
                    {intl.formatMessage({ id: `queue.complete.${action.toLowerCase()}` })}
                  </span>
                </span>
              </label>
            </div>
          )
        })}
      </div>
    </FormControl>
  )
}

export { CompleteQueueTypeRadioButton }
